import React, {Component} from 'react'
import {Field} from 'redux-form'
import NumberFormat from 'react-number-format'
// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
import analytics from '@cred/react-analytics/hoc/emitOnBlur'
import styles from './styles.module.scss'

/**
 * @deprecated Number is deprecated, please use @cred/react-basic-form-fields/Number or @cred/react-basic-form-fields/[reduxForm|hookForm]/Number instead.
 * @visibleName Number Editor
 */
class NumberEditor extends Component {
  render = () => <Field type="text" component={textInputWithAnalytics} {...this.props}/>
}

const textInput = field =>
    <NumberFormat
      className={styles[field.className]}
      thousandSeparator={field.thousandSeparator}
      prefix={field.prefix}
      suffix={field.suffix}
      allowNegative={field.allowNegative}
      type="text"
      placeholder={field.placeholder}
      {...field.input}
    />,
  textInputWithAnalytics = /*#__PURE__*/ analytics(textInput)

export {NumberEditor}
